<script>
import size from '@/components/base/size';
export default {
    mixins: [size],
    data () {
        return {
            globalConfig:{
                cellbeginedit:'',
                showHeader: true,
                showIndex: true,
                showStripe:false, 
                showBorder: true,
                showCheckBox: false,
                showCondition:false,
                readOnly: false,
                showPage: true,
                tableSize:'default',
                height: null,
                manualLoad: true,
                multiSelect: false,
                operFixedFlag:true,
                gridType:'viewGrid',
                items:[],
                pageConfig: {
                    page_no: 1,
                    page_size: 10,
                    total_results: 0,
                    pageSizeList: [10, 20, 50, 100]
                },
                moduleMethod:[]
            },
            data:[],
            delData:[],
            columns:[],
            expand:{},
            dictkey:'',
            currentDictData:{},
            editRowIndex:'',
            editRowFlag:true,
            loading:false,
            conditionSearchParam:{},
            showRowAction:false,
            modulecode:'',
            myToolConfig:{},
            showMoreBtn:false ,
            initData:[],
            showDelRow:false,
            showCondition:true,
            delRowAction:[{
                iconcls: 'row',
                name: 'delRow',
                text: '删除',
                type:'error'
            }],
            operFixedFlag:true,
            editIndex: -1,
            editKey:'',
            newRow:{}
        };
    },
    props: {
        config: {
            type: Object,
            default: () => {
                return {};          
            }
        },
        dictData: {
            type: Object,
            default:null
        },
        toolConfig: {
            type: Object,
            default: () => {
                return {};          
            }
        },
        isPop:{
            type: Boolean,
            default: false
        }
    },
    created () {
        this.init();
        this.modulecode = this.$Method.getUrlParam('modulecode');
        if (!this.modulecode) {
            this.modulecode = this.$Method.getUrlParam('billmoduleid');
        }
    },
    computed:{
        tableColumns() {
            this.newRow = {};
            this.columns = [];
            this.initColumn();
            return this.columns;
        },
        
    },
    methods: {
        init() {
            this.myConfig = Object.assign({},this.globalConfig,this.myConfig);

            if (this.config) {
                let config = this.$Method.copy(this.config);
                for (let temp in config) {
                    if (temp === 'pageConfig') {
                        for (let temp2 in config[temp]) {
                            this.myConfig.pageConfig[temp2] = config[temp][temp2];
                        }
                    } else {
                        this.myConfig[temp] = config[temp];
                    }
                }
            }
            if (this.dictData) {
                this.currentDictData = this.dictData;
            } else {
                this.currentDictData = [];
            }
            if (this.myConfig.showDelRow !== undefined) {
                this.showDelRow = this.myConfig.showDelRow;
            }

            if (this.myConfig.showCondition !== undefined) {
                this.showCondition = this.myConfig.showCondition;
            }
            this.myToolConfig = this.$Method.copy(this.toolConfig);

           // 非弹框模式
            if (!this.isPop) {
                // 判断是否显示更多 按钮
                let num = 0;
                if (this.myToolConfig.items) {
                    this.myToolConfig.items.forEach(el => {
                        if (el.iconcls === 'row') {
                            num++;
                        }
                    });
                }
                // 是否开启行编辑栏
                if (num > 0) {
                    this.showRowAction = true;
                } else {
                    this.showRowAction = false;
                }
                // 开启行编辑栏时checkbox显示
                if (this.showRowAction) {
                    if (!this.myConfig.showCheckBox) {
                        this.myConfig.showCheckBox = true;
                    }
                }
            }
            
            this.operFixedFlag = this.myConfig.operFixedFlag;
            this.setSizeConfig(this.myConfig);
            if (this.customInit) {
                this.customInit();
            }
        },
        initCheckColumn() {
            if (this.myConfig.showCheckBox) {
                let check = {};
                check.type = 'selection';
                check.align = 'center';
                check.width = 60;
                this.columns.push(check);
            }
        },
        isToolBar(obj) {
            let flag = false;
            if (this.myToolConfig && this.myToolConfig.items) {
                this.myToolConfig.items.forEach(el => {
                    if (el.iconcls === obj) {
                        flag = true;
                        return;
                    }
                });
            }
            return flag;
        } ,
        initIndexColumn() {
            if (this.myConfig.showIndex) {
                let index = {};
                index.type = 'index';
                index.key = 'index';
                index.width = 50;
                index.title = '行号';
                index.align = 'center';
                if (this.myConfig.showPage) {
                    index.indexMethod = this.indexRender;
                }
                this.columns.push(index);
            }
        },
        initOperColumn() {
            if (this.showRowAction || this.showDelRow) {
                let action ={};
                action.title = '操作';
                action.key = 'action';
                action.render = this.actionRender;
                if (this.operFixedFlag) {
                    action.fixed ='right';
                }
                action.width = 160;
                action.align = 'center';
                /* if (this.showDelRow) {
                    action.width = 80;
                } */
                if (this.customInitOperColumn) {
                    this.customInitOperColumn(action);
                } else {
                    this.columns.push(action);
                }
            }
        },
        initExpandColumn() {
            this.expand.items=[];
            let columns =[];
            for (let i = 0; i < this.columns.length; i++) {
                if (this.columns[i].isExpand === true) {
                    this.expand.items.push(this.columns[i]);
                } else {
                    columns.push(this.columns[i]);
                }
            }
            if (this.expand.items.length > 0) {
                this.columns = [];
                let expand =  {
                    type: 'expand',
                    width: 50,
                    render:this.expandRendel
                };
                const index =  columns.findIndex(item => item.type === 'index');
                if (index > -1 ) {
                    columns.splice(index+1, 0, expand);
                }  else {
                    const checkindex =  columns.findIndex(item => item.type === 'selection');
                    if (checkindex > -1) {
                        columns.splice(checkindex+1, 0, expand);
                    } else {
                        columns.splice(0, 0, expand);
                    }
                }
                this.columns = columns;
            }

        },
        initColumn() {
            this.initCheckColumn();
            this.initIndexColumn();
            const length = this.myConfig.items.length;
            for (let i = 0; i < length; i++) {
                if (this.myConfig.items[i].visible !== false) {
                    this.setColumn(i);  
                }
            }
            this.initExpandColumn();
            this.initOperColumn();
        },
        setColumn(i) {
            let  column = this.$Method.copy(this.myConfig.items[i]);
            if (!column.contentAlign) {
                column.contentAlign = column.align;
            }

            let type = '';
            if (column.type) {
                type = column.type.toLowerCase();
            }
            if (!type) {
                return;
            }
            column.title = column.label;
            column.key = column.name;
            if (Number(column.width)) {
                column.width = Number(column.width);
            } else {
                delete column.width;
            }

            if (!column.size) {
                column.size = 'large';
            }
            
            this.setColumnPro(column,type);
          
            if (type !== 'render') {
                if (column.render === undefined)  {
                    if (this.setCustomColumn) {
                        this.setCustomColumn(column);
                    }
                }
            }

            // 处理check
            if (type === 'checkbox' || type === 'picturebox') {
                column.render = this.commonRendel;
                if (type === 'picturebox') {
                    if (column.height === undefined) {
                        column.height = 40;
                    } 
                }
                if (this.myConfig.readOnly) {
                    column.readOnly = true;
                } else {
                    column.readOnly = false;
                }
               
            }
            if (column.required) {
                column.renderHeader = this.renderHeader;
            }
           
            // 事件绑定
            if (this.myConfig.items[i].valueChanged) {
                column.valueChanged = this.valueChanged;
            }
            if (this.myConfig.items[i].searchBefore) {
                column.searchBefore = this.searchBefore;
            }

            if (this.myConfig.items[i].setDataBefore) {
                column.setDataBefore = this.setDataBefore;
            }
            this.columns.push(column);
        },
        setColumnPro(column, type) {
            column.place = 'grid';
            switch(type) {
                case 'textbox' : 
                    this.newRow[column.key] = '';
                    break;
                case 'numberbox' : 
                    if (!column.align) {
                        column.align = 'right';
                    }
                    this.newRow[column.key] = '0';
                    break;
                case 'combobox' : 
                    if (column.data === undefined) {
                        column.data = this.currentDictData[column.dictkey];
                    } 
                    this.newRow[column.key] = '';  
                    break;
                case 'datebox' :
                    if (!column.align) {
                        column.align = 'center';
                    }
                    this.newRow[column.key] = '';  
                    break;
            }
            if (!column.align) {
                column.align = 'left';
            }
            if (column.defaultValue) {
                this.newRow[column.key] = column.defaultValue;
            }
        },
        expandRendel(h, params) {
            return h('div', [
                h('ExpandRow', {
                    props: {
                        config: this.expand,
                        valueData:params.row,
                        vstyle:'margin-right: 120px',
                        showRowAction:false
                    },
                    on: {
                        input: (val) => {
                            this.editIndex = params.index;
                            this.input(val);
                            //this.editValueChanged(params,val);
                        }      
                    }
                })
            ]);
        },
        renderHeader(h,params) {
            return h('span', {
                style: {
                    color: '#348eed'
                }
            }, params.column.title);
        },
        indexRender (row,_index) {
            let index  = _index + (this.myConfig.pageConfig.page_no - 1) * this.myConfig.pageConfig.page_size;
            return index;
        },
        actionRender (h, params) {
            return h('div', [
                h('Toolbar', {
                    props: {
                        config:this.myToolConfig,
                        tooltype:'row',
                        moduleMethod:this.globalConfig.moduleMethod
                    },
                    on: {
                        doAction: (val) => {                       
                            val.rowinfo = params;
                            if (val.name === 'editRowForm') {
                                if (this.initRowForm) {
                                    this.initRowForm(val);
                                }
                            } else if (val.name === 'delRow') {
                                if (this.delRow) {
                                    this.delRow(params.index);
                                }
                            } else {
                                this.$emit('doAction',val);
                            }
                        }
                    }
                })
            ]);
        },
        remove (index) {
            let _index =  this.data.findIndex(item => item._customIndex === index);
            if (_index ===  -1) {
                _index = index;
            }
            if (_index > -1) {
                if (this.data[_index].flag === undefined || this.data[_index].flag === 'U') {
                    this.data[_index].flag = 'D';
                    const row = this.$Method.copy(this.data[_index]);
                    this.delData.push(row); 
                }
                this.data.splice(_index, 1);
            }
        },
        setEdit(index) {
            if (this.editRowIndex === index) {
                this.editRowIndex = null;
            } else {
                this.editRowIndex = index;
            }
        },
        dbclick (e) {
            this.$emit('dbclick', e);
        },
        click (e) {
            this.$emit('click', e);
        },
        setData(data) {
            this.data = [];
            this.data = data;
            this.initData = this.$Method.copy(this.data);
            this.delData = [];
            if (this.cancelCellEditing) {
                this.cancelCellEditing();
            }
        },
        clearData() {
            this.editIndex = -1;
            this.editKey = '';
            this.data = [];
            this.delData = [];
            this.initData = [];
            this.conditionSearchParam = {};
            this.myConfig.pageConfig.page_no = 1;
            this.myConfig.pageConfig.total_results = 0;
        },
       
        updataRow(index, para) {
            let row = Object.assign({}, this.data[index], para);
            this.data.splice(index,1,row);
        },
        getModuleMethod() {
            this.modulecode = this.$Method.getUrlParam('modulecode');
            if (!this.modulecode) {
                this.modulecode = this.$Method.getUrlParam('billmoduleid');
            }
            this.token = this.$Method.getUrlParam('token');
            if (this.modulecode && this.token) {
                let btnList =  this.getUserModuleMethod();
                if (btnList) {
                    this.globalConfig.moduleMethod = btnList.modulemethod;
                }
            } 
        },
        getSelection() {
            return  this.$refs.table.getSelection();
        },
        input(obj) {
            let tempRow = {};
            if (obj.value !== undefined) {
                tempRow[obj.name] = obj.value;
            }
            if (obj.text !== undefined) {
                tempRow[obj.textName] = obj.text;
            }
            if (obj.svalue !== undefined) {
                tempRow[obj.sname] = obj.svalue;
            }
            if (obj.evalue !== undefined) {
                tempRow[obj.ename] = obj.evalue;
            }
            if (this.data[this.editIndex].flag === undefined) {
                tempRow.flag = 'U';
            }
            if (obj.customRows && obj.customRows.length > 0){
                let self = this;
                // 处理更新行
                obj.customRows.forEach(el => {
                    if (el.changeIndex !== undefined) {
                        let newRow = Object.assign({},self.data[el.changeIndex],el);
                        if (self.data[el.changeIndex].flag === undefined) {
                            newRow.flag = 'U';
                        }
                        self.data.splice(el.changeIndex,1,newRow);
                    }
                });
                // 处理新增行
                obj.customRows.forEach(el => {
                    if (el.changeIndex === undefined) {
                        let newRow = Object.assign({},{},el);
                        newRow.flag = 'I';
                        self.data.push(newRow);
                    }
                });
            } else {
                let newRow = Object.assign({},this.data[this.editIndex],tempRow);
                this.$nextTick(() => {
                    this.data.splice(this.editIndex,1,newRow); 
                });
                
            }

        },
        updateColPro(name, pro) {
            const index = this.myConfig.items.findIndex(item => name === item.name);
            if (index > -1) {
                let item = Object.assign({},this.myConfig.items[index],pro);
                this.myConfig.items.splice(index,1,item);
            }
        },
        commonRendel(h, params) {
            return h('div', [
                h('ControlBox', {
                    props: {
                        config: params.column,
                        valueData:params.row,
                    },
                    on: {
                        input: (val) => {
                            this.editIndex = params.index;
                            this.editKey = params.column.key;
                            this.input(val);
                        }      
                    }
                })
            ]);
        },
    },
    mounted () {
        let self = this;
        self.setCurrentHeight(self.myConfig.height); 
        window.onresize = function temp() {
            self.setCurrentHeight(self.myConfig.height); 
        };
    }
};
</script>


// WEBPACK FOOTER //
// src/components/grid/basicgrid.vue